import Cookies from 'js-cookie/src/js.cookie.js';
import {gsap} from 'gsap/dist/gsap.min';

export default {
  init() {
    // JavaScript to be fired on all pages
    $('.navbar-toggler').on('click', function() {
		$('html').toggleClass('nav-active');
	});
	function contentAnimation() {
	    var tl = gsap.timeline();
	    tl.from(".animate", { duration: 1, y: 30, opacity: 0, stagger: 0.4, delay: 0.2 });
	}
    $('#cookie-close-cookies').click(function() {
		$('#cookie-box-cookies').removeClass('show');
		$('body').removeClass('block');
		Cookies.set('cookie-close-cookies-accept', 'accepted', {
			expires: 30,
		});
	});
	if (Cookies.get('cookie-close-cookies-accept') == ('accepted')) {
		$('#cookie-box-cookies').removeClass('show');
		$('body').removeClass('block');
	} else {
		$('#cookie-box-cookies').addClass('show');
		$('body').addClass('block');
	}
	$('#cookie-answer-cookies').on('click', function() {
		$('.cookies-question').toggleClass('show');
		$('.cookies-answer').toggleClass('show');
	});
	$('.scrolldown').click(function() {
		$('html, body').animate({
		scrollTop: $($(this).attr('href')).offset().top - 50, 
		}, 400);
		return false;
	});
	function cleaner(e) {
		return e.toLowerCase().replace("á", "a").replace("é", "e").replace("í", "i").replace("ó", "o").replace("ú", "u")
	}
	function filter() {
		let e = cleaner(document.getElementById("filter").value),
			t = document.getElementsByClassName("searchable_");
		for (let n = 0; n < t.length; n++) {
			cleaner(t[n].firstChild.nextSibling.innerHTML).includes(e)?t[n].style.display = "inline-block": t[n].style.display = "none"
		}
	}
	if(document.getElementById("filter") != null) {
		document.getElementById("filter").addEventListener("search", filter), document.getElementById("filter").addEventListener("keyup", filter), document.addEventListener("submit", function(e) {
			e.preventDefault()
		});
	}
	$(function() {
		$('.two-lines').html(function() {
			var html = $(this).html().split(' ');
			html = html[0] + '<br />' + html.slice(1).join(' ');
			$(this).html(html);
		});
	})
	if ($(window).width() >= 800) {
		var $circle = $('.cursor');
		function moveCircle(e) {
			gsap.to($circle, 0.3, {
				css: {
					left: e.pageX,
					top: e.pageY,
				},
			});
		}
		$(window).on('mousemove', moveCircle);
		$('.btn, .module-hero, .module-design, .module-story-summary, footer, .navbar-collapse').mouseover(function() {
			$('.cursor').addClass('active');
		});
		$('.btn, .module-hero, .module-design, .module-story-summary, footer, .navbar-collapse').mouseout(function() {
			$('.cursor').removeClass('active');
		});
		$('#iframe-spot').mouseover(function() {
			$('.cursor').addClass('d-none');
		});
		$('#iframe-spot').mouseout(function() {
			$('.cursor').removeClass('d-none');
		});
	}
	$('.play-video').click(function(e) {
		e.preventDefault(); var o = $('#iframe-spot').attr('data-src'); 1 == $(this).attr('data-click-state') ? ($('.video-wrap').removeClass('playing'), $(this).attr('data-click-state', 0), $('video').get(0).play(), gsap.to($('.play-video'), .3, {
			opacity: 1, 
		}).delay(.3), $('#iframe-spot').attr('src', '')) : ($(this).attr('data-click-state', 1), $('.video-wrap').addClass('playing'), $('#iframe-spot').attr('src', o), gsap.to($('.play-video'), .3, {
			opacity: 0,
		}).delay(.3), gsap.to($('.module-hero .content'), .3, {
			opacity: 0,
			y: -300,
		}).delay(.3), $('video').get(0).pause())
	});
	$('.slider-gallerys .slider-inner').slick({
		dots: false,
		infinite: false,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		variableWidth: true,
		swipeToSlide: false,
		focusOnSelect: false,
		centerMode: false,
		cssEase: 'ease-in',
		appendArrows: '.slider-gallerys .slider-control',
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 1,
					variableWidth: false,
					adaptiveHeight: true,
				},
			},
		],
	});
	
	$('.slider-gallery .slider-inner').slick({
		dots: false,
		infinite: false,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		variableWidth: true,
		swipeToSlide: true,
		focusOnSelect: false,
		centerMode: false,
		cssEase: 'ease-in',
		appendArrows: '.slider-gallery .slider-control',
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 1,
					centerMode: false,
					variableWidth: false,
					adaptiveHeight: true,
				},
			},
		],
	});
	
	$('.slider-color .slider-inner').slick({
		dots: true,
		arrows: false,
		infinite: true,
		fade: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 3000,
		variableWidth: false,
		swipeToSlide: false,
		focusOnSelect: false,
		centerMode: false,
		cssEase: 'ease-in',
	});
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js